/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInventoryLogsReportQuery } from '../../models/get-inventory-logs-report-query';
import { GetInventoryLogsReportQueryResult } from '../../models/get-inventory-logs-report-query-result';

export interface ApiNurseryManagerReportsGetLogsReportPost$Plain$Params {
      body?: GetInventoryLogsReportQuery
}

export function apiNurseryManagerReportsGetLogsReportPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetLogsReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryLogsReportQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetLogsReportPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInventoryLogsReportQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetLogsReportPost$Plain.PATH = '/api/NurseryManager/Reports/GetLogsReport';
